import { createSystemColor } from './color';
import pointer from './pointer';
import screenSize from './screenSize';
import scrollCss from './scroll';
import { textShadow } from './textShadow';

const theme = {
  textShadow,
  screenSize,
  pointer,
  // 순환 참조 방지 목적으로 getter 적용
  get scroll() {
    return scrollCss;
  },
  // 해당 값부터는 더미값으로 우선 적용 후 ThemeProvider에서 올바른 값으로 오버라이딩됨
  isDark: true,
  color: createSystemColor(true),
  isRtl: false,
};

export default theme;
